import { geoJSONType } from "../utils/constants";
import { Product } from "./product";
import { SubZone } from "./subZone";
import { UserType } from "./user";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const geoJsonTypes: (
  | "Point"
  | "LineString"
  | "Polygon"
  | "Multipoint"
  | "MultiLineString"
  | "MultiPolygon"
)[] = Object.values(geoJSONType);

type GeoJSON = {
  type: (typeof geoJsonTypes)[number];
  coordinates: number[];
};

interface Address {
  fullName: string;
  street: string;
  colony: string;
  exteriorNumber: string;
  postcode: string;
  city: string;
  country: string;
  state: string;
  location: GeoJSON;
}

type Location = {
  workingHours: any;
  id: string;
  key: string;
  name: string;
  phone: string;
  subZone: SubZone;
  address: Address;
  products: Product[]
  users: UserType[]
  img: string;
  collectionInstructions: string;
  operations: {
    integrations: any;
    workingHours: {
      monday: {
        open: Date;
        close: Date;
      };
      tuesday: {
        open: Date;
        close: Date;
      };
      wednesday: {
        open: Date;
        close: Date;
      };
      thursday: {
        open: Date;
        close: Date;
      }
      friday: {
        open: Date;
        close: Date;
      };
      saturday: {
        open: Date;
        close: Date;
      };
      sunday: {
        open: Date;
        close: Date;
      };
    }
    holidays: {
      date: string;
      repeat: boolean;
    }[];
  }
};

const baseAddress: Address = {
  fullName: "",
  street: "",
  colony: "",
  exteriorNumber: "",
  postcode: "",
  city: "",
  country: "",
  state: "",
  location: {
    type: geoJSONType.Point,
    coordinates: [],
  },
};

interface GMapsAddressComponent {
  long_name: string;
  types: string[];
}

interface GoogleAddress {
  address_components: GMapsAddressComponent[];
}

interface GMapsQueryLocation {
  address: GoogleAddress[];
  result: string;
  lat: number;
  lng: number;
}

interface GMapsFormattedAddress {
  country?: string;
  state?: string;
  city?: string;
  colony?: string;
  street?: string;
  postcode?: string;
  neighborhood?: string;
  fullName?: string;
  exteriorNumber?: string;
  location?: {
    type: "Point";
    coordinates: [number, number];
  };
}

export { baseAddress };

export type {
  Address,
  Location,
  GMapsQueryLocation,
  GMapsFormattedAddress,
  GeoJSON,
};
